/**
 * Created by vladislav on 29.10.2021
 */

const DrawCallsDebugger = function () {
    this.entries = [];
    this.marked = {};
};

DrawCallsDebugger.prototype.addEntry = function (node) {
    const frame = cc.director.getTotalFrames();

    if (this.currentFrame !== frame) {
        this.currentFrame = frame;
        this.entries.length = 0;
    }

    this.entries.push({
        node,
        numberOfDraw: this.getNumberOfDraw()
    });
};

DrawCallsDebugger.prototype.debugDrawCalls = function () {
    if (this.running) {
        return;
    }

    const marked = Object.values(this.marked);
    if (marked.length) {
        marked.forEach((node) => {
            node.cleanupBorder();
        });

        this.marked = {};
        this.entries = [];

        return;
    }

    this.running = true;

    setTimeout(() => {
        this.analyzeDrawCalls();

        this.running = false;
    }, 100);
};

DrawCallsDebugger.prototype.analyzeDrawCalls = function () {
    const labels = {};

    this.marked = {};

    this.entries.forEach((entry) => {
        const node = entry.node;

        this.marked[node.__instanceId] = entry.node;

        labels[node.__instanceId] = labels[node.__instanceId] ? `${labels[node.__instanceId]},${entry.numberOfDraw}` : `${entry.numberOfDraw}`;

        console.log(`${entry.numberOfDraw} ${this.describeNode(entry.node)}`);
    });

    Object.values(this.marked).forEach((node) => {
        node.debugBorder({
            labelText: labels[node.__instanceId],
            noResLinks: true
        });
    });

    console.log(`${this.getNumberOfDraw()} draw calls`);
    console.log(`${this.getNumberOfVertices()} vertexes`);
};

DrawCallsDebugger.prototype.describeNode = function (node) {
    let info = `${node.debugGetName()} #${node.__instanceId}`;
    if (node instanceof cc.LabelTTF) {
        info += ` ${node.getString()}`;
    }
    const virtualResource = node.virtualResource;
    if (virtualResource) {
        info += ` ${virtualResource.toString()}`;
    }
    const textureBundle = node.getTextureBundle && node.getTextureBundle();
    if (textureBundle) {
        info += ` ${textureBundle}`;
    }
    if (node.jsonName instanceof VirtualResource) {
        info += ` ${node.jsonName.toString()}`;
    }
    return info;
};

DrawCallsDebugger.prototype.getNumberOfDraw = function () {
    return cc.g_NumberOfDraws;
};

DrawCallsDebugger.prototype.getNumberOfVertices = function () {
    return cc.g_NumberOfVertexes;
};

cc.Node.prototype.showDrawCall = function () {
    if (cleverapps.drawCallsDebugger && cleverapps.drawCallsDebugger.running) {
        cleverapps.drawCallsDebugger.addEntry(this);
    }
};
